import ReportSchedule from '@/models/report-schedule'
import BtnIcon from '@/components/button/BtnIcon'
import Chips from '@/components/Chips'
import TextAnsweredAt from '@/components/text/TextAnsweredAt'
import TimeSupport from '@/utils/time-support'

export default {
  components: {
    BtnIcon,
    Chips,
    TextAnsweredAt
  },
  props: {
    value: {
      type: ReportSchedule,
      required: true,
    },
  },
  computed: {
    vCardColor () {
      if (this.value.isAnswered) return "blue-grey lighten-5"
      return null
    },
    endAt () {
      return this.value.end_at.humanWithSuffix(this.$t('text.endAtSuffix'))
    },
    lastAnsweredAt () {
      if (this.value.isAnswered)
        return this.value.answered_report.created_at
      return
    }
  },
  methods: {
    onAnswer () {
      this.$emit('on-answer', this.value)
    }
  }
}
